import { SegmentationIds } from 'constants/segmentation';
import {
  TestDataConfig5970,
  TestDataConfig5971,
} from 'interfaces/reviews-test';
import { useWidgetEvent } from 'modules/product-details/components/judge-me-reviews/use-judge-me-reviews-tracking';
import { RefObject, useEffect, useRef } from 'react';
import { StaticPDPProduct } from '../../../modules/product-details/types';
import {
  addFakeReviews,
  changeReviewCountStyle,
  disableSort,
  updateReviewCount,
} from './utils';

/**
 * Hacky way to modify JudgeMe widget.
 * In the future we should perhaps think about moving the fetching of this data to our backend and have more flexibility.
 */
const useModifyJudgeMe = ({
  data5971,
  loading5970,
  loading5971,
  product,
  segmentId,
  data5970,
  variant5971,
}: {
  data5971: TestDataConfig5971 | undefined;
  loading5970: boolean;
  loading5971: boolean;
  product: StaticPDPProduct;
  segmentId?: SegmentationIds;
  data5970: TestDataConfig5970 | undefined;
  variant5971: number | undefined;
}): RefObject<HTMLDivElement> => {
  const widgetRef = useRef<HTMLDivElement>(null);
  const hasAppliedFakeValues = useRef(false);

  const reviewCount = data5970 && data5970[product.id];
  const productData = data5971 && data5971.productData[product.id];

  /**
   * Attach click event to load more button to remove it after click
   */
  useWidgetEvent(
    widgetRef.current,
    '.jdgm-paginate__load-more',
    'click',
    () => {
      const loadMoreButton = widgetRef.current?.querySelector('.jdgm-paginate');
      if (loadMoreButton && (reviewCount || productData)) {
        setTimeout(() => {
          loadMoreButton.remove();
          // Slightly delay the update to give time for the reviews to load
        }, 100);
      }
    }
  );

  /**
   * Change review count style for no-test products
   */
  useEffect(() => {
    const refreshWidget = (): void => {
      if (widgetRef.current) changeReviewCountStyle(widgetRef.current);
    };

    const timeout: NodeJS.Timeout = setTimeout(refreshWidget, 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, [product]);

  /**
   * Modify the widget with the fake values
   */
  useEffect(() => {
    const refreshWidget = (): void => {
      if (widgetRef.current && reviewCount) {
        disableSort(widgetRef.current);
        updateReviewCount({
          hasAppliedFakeValues: hasAppliedFakeValues.current,
          reviewCount: reviewCount,
          widgetRef: widgetRef.current,
        });
      }

      if (widgetRef.current && productData) {
        disableSort(widgetRef.current);
        if (variant5971 === 2) {
          addFakeReviews({
            reviewData: segmentId
              ? productData[segmentId]
              : productData.default,
            widgetRef: widgetRef.current,
          });
        }
        updateReviewCount({
          hasAppliedFakeValues: hasAppliedFakeValues.current,
          reviewCount: data5971.globalReviewCount,
          widgetRef: widgetRef.current,
        });
      }
    };

    let timeout: NodeJS.Timeout;
    if ((!loading5971 || !loading5970) && (data5971 || data5970)) {
      timeout = setTimeout(refreshWidget, 1000);
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [
    data5970,
    data5971,
    loading5970,
    loading5971,
    product,
    segmentId,
    variant5971,
    productData,
    reviewCount,
  ]);
  return widgetRef;
};

export default useModifyJudgeMe;
